import { useCallback, useEffect, useRef, useState } from "react";
import { provinceData } from "./index";
import { provinceOldData } from './oldAddress'
import { Button } from 'common/button'
import { Input } from 'common/form/input'
import { Text } from 'common/text'
import { THEME_SEMANTICS } from 'common/theme/_semantics'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { debounce } from "@mui/material";
import { sendRequestAuth } from "../../api/api";
import config from "../../config";
import ArrayUtils from "util/array";
import useAlert from "../../hook/useAlert";
import { GLOBAL_ICON } from "../../interfaceGlobal";

export const AddressSplit = ({ showLabel = true, require = true, twoLevels = true, ...props }) => {
    const { t } = useTranslation()
    const dropdownRef = useRef(null)
    const { showAlert } = useAlert()
    const { province, ward, district } = props

    const [suggestList, setSuggestList] = useState([])
    const [value, setValue] = useState(props.value || '')
    const [validate, setValidate] = useState('')
    const [reversePlacement, setReversePlacement] = useState(false)

    const debouncePostKeywordChange = useCallback(debounce((data) => {
        handleAddressChangeDebounce(data)
    }, 500), [])
    const debounceSubmit = useCallback(debounce((data) => {
        handleSplitAddress(data)
    }, 500), [])
    const handleAddressChangeDebounce = async data => {
        const response = await sendRequestAuth(
            'get',
            `${config.API}/area/suggest-address?keyword=${data.keyword}&city_id=&ward_id`,
        )
        if (!!response?.data?.success) {
            setSuggestList(response?.data?.data)
        }
    }
    const handleUpdateAddress = value => {
        setValue(value)
        setValidate('')
        if (props.onChange)
            props.onChange(value)
        const data = {
            'keyword': value.trim(),
        }
        debouncePostKeywordChange(data)
    }
    const handleSelectItem = item => {
        const isTwoLevels = +item?.is_two_levels === 1

        const address = isTwoLevels
            ? [item?.suggest, item?.ward_name, item?.city_name]
                .filter(Boolean)
                .join(', ')
            : [item?.suggest, item?.ward_name, item?.district_name, item?.city_name]
                .filter(Boolean)
                .join(', ')
        setSuggestList([])
        setValue(address)
        props.onSetUnit(+item?.is_two_levels)
        if (props.onChange) props.onChange(address)
        if (+item.is_two_levels === 1) {
            const findProvince = provinceData.find(
                province => province?.value == item?.city_id,
            )
            if (findProvince) province.onChange(findProvince)
            const findWard = ArrayUtils.getQualifiedArray(findProvince?.list)
                .find(ward => ward?.value == item?.ward_id)
            if (findWard)
                ward.onChange(findWard)
        } else {
            const findProvince = provinceOldData.find(
                province => province?.value == item?.city_id,
            )
            if (findProvince) province.onChange(findProvince)
            const findDistrict = ArrayUtils.getQualifiedArray(findProvince?.list)
                .find(district => district?.value == item?.district_id)
            if (findDistrict)
                district.onChange(findDistrict)
            const findWard = ArrayUtils.getQualifiedArray(findDistrict?.list)
                .find(ward => ward?.value == item?.ward_id)
            if (findWard)
                ward.onChange(findWard)
        }
        
    }
    const handleSplitAddress = async (address) => {
        if (!!address) {
            setValidate('')
            const response = await sendRequestAuth(
                'get',
                `${config.API}/area/detect-address?address=${address.trim()}`,
            )

            if (!!response?.data?.success) {
                const data = response?.data?.data
                const apiIsTwo = +data?.is_two_levels
                const currentUnit = props?.unitVersion?.value != null ? +props?.unitVersion?.value : apiIsTwo
                const isTwoLevelParseSuccess = !!(
                    (data?.city_id ||
                    data?.ward_id) &&
                    (+data?.city_id !== 0 ||
                    +data?.ward_id !== 0)
                )
                const isThreeLevelParseSuccess = !!(
                  (  data?.city_id ||
                    data?.district_id ||
                    data?.ward_id) &&
                   ( +data?.city_id !== 0 ||
                    +data?.district_id !== 0 ||
                    +data?.ward_id !== 0)
                )
                const isParseSuccess = apiIsTwo === 1 ? isTwoLevelParseSuccess : isThreeLevelParseSuccess
                const isParseFailed = !data || data?.length <= 0 || !isParseSuccess
                // keep current unit on failed parse so validation stays visible in the active AddressSplit
                const isTwo = props?.unitVersion?.disabled
                    ? currentUnit
                    : (isParseFailed ? currentUnit : apiIsTwo)
                if (props?.onSetUnit && !isParseFailed) props.onSetUnit(isTwo)
                if (isTwo === 1) {
                    const findProvince = provinceData.find(
                        item => item?.value === `${response?.data?.data?.city_id}`,
                    )
                    if (findProvince) province.onChange(findProvince)
                    const findWard = ArrayUtils.getQualifiedArray(findProvince?.list)
                        .find(item => item?.value === `${response?.data?.data?.ward_id}`)
                    if (findWard)
                        ward.onChange(findWard)
                    if (props.onChange) props.onChange(address)
                    if (!!response?.data?.data &&
                        !!response?.data?.data?.city_id &&
                        !!response?.data?.data?.ward_id) showAlert({ type: 'success', content: t('address_parsing_success') })
                    if (response?.data?.data.length <= 0) {
                        if (!!address) setValidate(t('customer_page_invalid_separate'))
                        else setValidate(t('address_must_not_empty'))
                    } else {
                        if (
                            response?.data?.data?.city_id == 0 &&
                            response?.data?.data?.ward_id == 0 ||
                            response?.data?.data?.length == 0
                        ) {
                            setValidate(t('customer_page_invalid_separate'))
                        }
                    }
                } else {
                    const findProvince = provinceOldData.find(
                        item => item?.value === `${response?.data?.data?.city_id}`,
                    )
                    if (findProvince) province.onChange(findProvince)
                    const findDistrict = ArrayUtils.getQualifiedArray(findProvince?.list)
                        .find(item => item?.value === `${response?.data?.data?.district_id}`)
                    if (findDistrict)
                        district.onChange(findDistrict)
                    const findWard = ArrayUtils.getQualifiedArray(findDistrict?.list)
                        .find(item => item?.value === `${response?.data?.data?.ward_id}`)
                    if (findWard)
                        ward.onChange(findWard)
                    if (props.onChange) props.onChange(address)
                    if (!!response?.data?.data &&
                        !!response?.data?.data?.city_id &&
                        !!response?.data?.data?.district_id &&
                        !!response?.data?.data?.ward_id) showAlert({ type: 'success', content: t('address_parsing_success') })
                    if (response?.data?.data.length <= 0) {
                        if (!!address) setValidate(t('customer_page_invalid_separate'))
                        else setValidate(t('address_must_not_empty'))
                    } else {
                        if ((
                            response?.data?.data?.city_id == 0 &&
                            response?.data?.data?.district_id == 0 &&
                            response?.data?.data?.ward_id == 0) ||
                            response?.data?.data?.length == 0
                        ) {
                            setValidate(t('customer_page_invalid_separate'))
                        }
                    }
                }
            }
        } else {
            showAlert({ type: 'danger', content: t('address_must_not_empty') })
        }
    }
    const handleReversePlacement = () => {
        if (!!dropdownRef.current) {
            const viewportOffset = dropdownRef.current.getBoundingClientRect()
            // these are relative to the viewport, i.e. the window
            const top = viewportOffset.top
            // setReversePlacement(top + 500 > screen.height || top - 50 < 0)
            setReversePlacement(top + 600 > screen.height)
        }
    }
    useEffect(() => {
        if (suggestList.length > 0) {
            handleReversePlacement()
        }
    }, [suggestList])
    useEffect(() => {
        if (props.validateText)
            setValidate(props.validateText)
    }, [props.validateText])
    useEffect(() => {
        setValue(props.value)
        if (props.value) {
            setValidate('')
        }
    }, [props.value])
    return (
        <StyledSuggestAddressSearchList className={props.className}>
            <div ref={dropdownRef}></div>
            <Input
                {...props}
                className="split-address-infor"
                // dropdown={() => (
                //     <div>
                //         {suggestList?.length > 0 &&
                //             <div className="suggest-search-list">
                //                 {suggestList.map(item => (
                //                     <Item
                //                         key={item?.value}
                //                         data={item}
                //                         onClick={() => { handleSelectItem(item) }}
                //                     />
                //                 ))}
                //             </div>}
                //     </div>
                // )}
                // button={
                //     <Button
                //         icon={GLOBAL_ICON.target}
                //         onClick={() => debounceSubmit(value)}
                //     >
                //         {t('split')}
                //     </Button>
                // }
                placeholder={twoLevels ? t('address_province_ward') : t('address_province_district_ward')}
                value={value}
                onChange={e => handleUpdateAddress(e.target.value)}
                validateText={!!validate ? validate : ''}
                validateType="danger"
                reversePlacement={reversePlacement}
            />
        </StyledSuggestAddressSearchList>
    )
}
const Item = ({ data, ...props }) => {

    return (
        <div
            {...props}
            className={`suggest-search-list__item ${props?.className || ''}`}
        >
            <div className="suggest-search-list__info">
                <div className="suggest-search-list__name">
                    {data?.suggest}, {data?.ward_name}{+data?.is_two_levels === 0 ? `, ${data?.district_name}` : ''} , {data?.city_name}
                </div>
                <div className="suggest-search-list__name_sm">
                    {data?.ward_name}/{data?.city_name}
                </div>
            </div>
        </div>
    )
}
const StyledSuggestAddressSearchList = styled.div`
  width: 100%;
  .suggest-search-list{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding:16px;
    
    &__info {
      &:hover {
        cursor: pointer;
      }
    }

    &__item {
      gap: 2px;
      isolation: isolate;
      
      width: 571px;
      height: 55px;
    }
    &__name {
      font-weight: 500;
      font-size: 14px;
      line-height: 140%;
      color: #00081D;
      
      &_sm {
        font-weight: 400;
        font-size: 12px;
        line-height: 140%;
        color: #7C88A6;
      }
    }
  }
  .split-address-infor {
    .input__dropdown {
      padding: 0px
    }
  }
  &.confirm-info-address-split {
    .split-address-infor {
      .input__input {
        height: 44px !important;
      }
      .input__button {
        height: 44px !important;
      }
    }
  }
  .button-split-address{
    position: absolute;
    right: 1px;
    height: 32px !important;
  }
`